var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-container full-height" },
    [
      _vm.device == "mobile" &&
      (_vm.toUser || _vm.groupToUser || _vm.panel === "discussionChat")
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.chatLoading || _vm.discussionChatLoading,
                  expression: "chatLoading || discussionChatLoading",
                },
              ],
              staticClass: "messageDialog",
              attrs: {
                title:
                  _vm.panel === "chat"
                    ? "聊天訊息"
                    : _vm.panel === "groupChat"
                    ? "群組聊天"
                    : "討論區",
                visible: _vm.dialogMessageVisible,
                fullscreen: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogMessageVisible = $event
                },
                closed: function ($event) {
                  return _vm.obDialogClosed()
                },
              },
            },
            [
              _c(
                "el-card",
                {
                  staticClass:
                    "box-card el-card-define chat-window full-height",
                  attrs: {
                    "body-style": { height: "88%", "overflow-y": "scroll" },
                  },
                },
                [
                  _vm.panel === "chat"
                    ? _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.formatShowUserName(_vm.toUser.userName)
                              )
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.panel === "groupChat"
                    ? _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.formatShowUserName(_vm.groupToUser.userName)
                              )
                            ),
                          ]),
                          _c(
                            "div",
                            { staticStyle: { float: "right" } },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-right": "8px",
                                    "font-size": "12px",
                                    color: "red",
                                  },
                                },
                                [
                                  _vm._v(
                                    "若關閉此團所有人皆無法使用群組聊天功能"
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-right": "8px",
                                    "font-size": "14px",
                                  },
                                  style: {
                                    color: _vm.groupToUser.openGroupChat
                                      ? "#000"
                                      : "#409EFF",
                                  },
                                },
                                [_vm._v("關")]
                              ),
                              _c("el-switch", {
                                attrs: {
                                  disabled: _vm.switchLoading,
                                  "active-color": "#13ce66",
                                  "inactive-color": "#ff4949",
                                },
                                on: { change: _vm.handleOpenGroupChatChange },
                                model: {
                                  value: _vm.groupToUser.openGroupChat,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.groupToUser,
                                      "openGroupChat",
                                      $$v
                                    )
                                  },
                                  expression: "groupToUser.openGroupChat",
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-left": "8px",
                                    "font-size": "14px",
                                  },
                                  style: {
                                    color: _vm.groupToUser.openGroupChat
                                      ? "#409EFF"
                                      : "#000",
                                  },
                                },
                                [_vm._v("開")]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.panel === "discussionChat"
                    ? _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              '所有APP使用者在活動結束後皆會自動加入討論區 (團體管理/其他設定/顯示資訊，設定"隱藏"則不會加入)'
                            ),
                          ]),
                          _c(
                            "div",
                            { staticStyle: { float: "right" } },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-right": "8px",
                                    "font-size": "12px",
                                    color: "red",
                                  },
                                },
                                [_vm._v("※點擊旅客姓名可將他移除本討論區")]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-right": "8px",
                                    "font-size": "12px",
                                    color: "red",
                                  },
                                },
                                [
                                  _vm._v(
                                    "若關閉此功能所有人皆無法使用討論區聊天功能"
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-right": "8px",
                                    "font-size": "14px",
                                  },
                                  style: {
                                    color: _vm.discussionChatSwitch
                                      ? "#000"
                                      : "#409EFF",
                                  },
                                },
                                [_vm._v("關")]
                              ),
                              _c("el-switch", {
                                attrs: {
                                  disabled: _vm.switchLoading,
                                  "active-color": "#13ce66",
                                  "inactive-color": "#ff4949",
                                },
                                on: {
                                  change: _vm.handleOpenDiscussionChatChange,
                                },
                                model: {
                                  value: _vm.discussionChatSwitch,
                                  callback: function ($$v) {
                                    _vm.discussionChatSwitch = $$v
                                  },
                                  expression: "discussionChatSwitch",
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-left": "8px",
                                    "font-size": "14px",
                                  },
                                  style: {
                                    color: _vm.discussionChatSwitch
                                      ? "#409EFF"
                                      : "#000",
                                  },
                                },
                                [_vm._v("開")]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  (_vm.panel === "chat" &&
                    _vm.filtered_list.length > 0 &&
                    _vm.filtered_list[0] &&
                    _vm.filtered_list[0].messages &&
                    _vm.filtered_list[0].messages.length > 0) ||
                  (_vm.panel === "groupChat" &&
                    _vm.filtered_group_list.length > 0 &&
                    _vm.filtered_group_list[0] &&
                    _vm.filtered_group_list[0].messages &&
                    _vm.filtered_group_list[0].messages.length > 0) ||
                  (_vm.panel === "discussionChat" &&
                    _vm.discussionChatList.length > 0 &&
                    _vm.discussionChatList[0] &&
                    _vm.discussionChatList[0].messages &&
                    _vm.discussionChatList[0].messages.length > 0)
                    ? [
                        _vm._l(
                          _vm.filtered_list[0].messages,
                          function (item, index) {
                            return _vm.panel === "chat"
                              ? _c(
                                  "div",
                                  { key: "chat-" + index },
                                  [
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 24 } }, [
                                          _c(
                                            "div",
                                            { staticClass: "chat-date" },
                                            [
                                              _c("el-tag", [
                                                _vm._v(_vm._s(item.date)),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 24 } },
                                          _vm._l(
                                            item.charMsgInfos,
                                            function (d, ind) {
                                              return _c(
                                                "div",
                                                {
                                                  key: ind,
                                                  staticClass: "chat-receive",
                                                },
                                                [
                                                  d.from != _vm.fromUser &&
                                                  d.from !=
                                                    _vm.groupToUser.userID
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "chat-container-from",
                                                        },
                                                        [
                                                          _c("div", [
                                                            d.chatType == 1
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "chat-content-form",
                                                                    attrs: {
                                                                      closable: false,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          d.msg
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            d.chatType == 2 &&
                                                            d.fileInfo &&
                                                            d.fileInfo.url
                                                              ? _c(
                                                                  "span",
                                                                  [
                                                                    _c(
                                                                      "el-image",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            width:
                                                                              "100px",
                                                                            height:
                                                                              "100px",
                                                                          },
                                                                        attrs: {
                                                                          "preview-src-list":
                                                                            [
                                                                              d
                                                                                .fileInfo
                                                                                .url,
                                                                            ],
                                                                          src: d
                                                                            .fileInfo
                                                                            .url,
                                                                          fit: "cover",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "time-flag",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      d.time
                                                                    )
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  d.from == _vm.fromUser ||
                                                  d.from ==
                                                    _vm.groupToUser.userID
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "chat-container-send",
                                                          staticStyle: {
                                                            "text-align":
                                                              "right",
                                                          },
                                                        },
                                                        [
                                                          _c("div", [
                                                            d.isRead
                                                              ? _c(
                                                                  "i",
                                                                  {
                                                                    staticClass:
                                                                      "read-flag",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "已讀"
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "time-flag",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(d.time)
                                                                ),
                                                              ]
                                                            ),
                                                            d.chatType == 1
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "chat-content-send",
                                                                    attrs: {
                                                                      closable: false,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          d.msg
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            d.chatType == 2 &&
                                                            d.fileInfo &&
                                                            d.fileInfo.url
                                                              ? _c(
                                                                  "span",
                                                                  [
                                                                    _c(
                                                                      "el-image",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            width:
                                                                              "100px",
                                                                            height:
                                                                              "100px",
                                                                          },
                                                                        attrs: {
                                                                          src: d
                                                                            .fileInfo
                                                                            .url,
                                                                          fit: "cover",
                                                                          "preview-src-list":
                                                                            [
                                                                              d
                                                                                .fileInfo
                                                                                .url,
                                                                            ],
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e()
                          }
                        ),
                        _vm._l(
                          _vm.filtered_group_list[0].messages,
                          function (item, index) {
                            return _vm.panel === "groupChat"
                              ? _c(
                                  "div",
                                  { key: "group-" + index },
                                  [
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 24 } }, [
                                          _c(
                                            "div",
                                            { staticClass: "chat-date" },
                                            [
                                              _c("el-tag", [
                                                _vm._v(_vm._s(item.date)),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 24 } },
                                          _vm._l(
                                            item.charMsgInfos,
                                            function (d, ind) {
                                              return _c(
                                                "div",
                                                {
                                                  key: ind,
                                                  staticClass: "chat-receive",
                                                },
                                                [
                                                  d.from != _vm.fromUser &&
                                                  d.from !=
                                                    _vm.groupToUser.userID
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "chat-container-from",
                                                        },
                                                        [
                                                          _c("div", [
                                                            d.chatType == 1
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "chat-content-form",
                                                                    attrs: {
                                                                      closable: false,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          d.from
                                                                        ) +
                                                                        "：" +
                                                                        _vm._s(
                                                                          d.msg
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            d.chatType == 2 &&
                                                            d.fileInfo &&
                                                            d.fileInfo.url
                                                              ? _c(
                                                                  "span",
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "chat-content-form",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              d.from
                                                                            ) +
                                                                            "： "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "el-image",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            width:
                                                                              "100px",
                                                                            height:
                                                                              "100px",
                                                                          },
                                                                        attrs: {
                                                                          "preview-src-list":
                                                                            [
                                                                              d
                                                                                .fileInfo
                                                                                .url,
                                                                            ],
                                                                          src: d
                                                                            .fileInfo
                                                                            .url,
                                                                          fit: "cover",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            d.chatType == 4
                                                              ? _c(
                                                                  "span",
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "chat-content-form",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              d.from
                                                                            ) +
                                                                            "： "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "el-image",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            width:
                                                                              "100px",
                                                                            height:
                                                                              "100px",
                                                                          },
                                                                        attrs: {
                                                                          src: "https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png",
                                                                          fit: "cover",
                                                                          "preview-src-list":
                                                                            [
                                                                              "https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png",
                                                                            ],
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "time-flag",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      d.time
                                                                    )
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  d.from == _vm.fromUser ||
                                                  d.from ==
                                                    _vm.groupToUser.userID
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "chat-container-send",
                                                          staticStyle: {
                                                            "text-align":
                                                              "right",
                                                          },
                                                        },
                                                        [
                                                          _c("div", [
                                                            d.isRead
                                                              ? _c(
                                                                  "i",
                                                                  {
                                                                    staticClass:
                                                                      "read-flag",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "已讀"
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "time-flag",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(d.time)
                                                                ),
                                                              ]
                                                            ),
                                                            d.chatType == 1
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "chat-content-send",
                                                                    attrs: {
                                                                      closable: false,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          d.msg
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            d.chatType == 2 &&
                                                            d.fileInfo &&
                                                            d.fileInfo.url
                                                              ? _c(
                                                                  "span",
                                                                  [
                                                                    _c(
                                                                      "el-image",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            width:
                                                                              "100px",
                                                                            height:
                                                                              "100px",
                                                                          },
                                                                        attrs: {
                                                                          src: d
                                                                            .fileInfo
                                                                            .url,
                                                                          fit: "cover",
                                                                          "preview-src-list":
                                                                            [
                                                                              d
                                                                                .fileInfo
                                                                                .url,
                                                                            ],
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            d.chatType == 4
                                                              ? _c(
                                                                  "span",
                                                                  [
                                                                    _c(
                                                                      "el-image",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            width:
                                                                              "100px",
                                                                            height:
                                                                              "100px",
                                                                          },
                                                                        attrs: {
                                                                          src: "https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png",
                                                                          fit: "cover",
                                                                          "preview-src-list":
                                                                            [
                                                                              "https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png",
                                                                            ],
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e()
                          }
                        ),
                        _vm._l(
                          _vm.discussionChatList[0].messages,
                          function (item, index) {
                            return _vm.panel === "discussionChat" &&
                              _vm.discussionChatList.length > 0 &&
                              _vm.discussionChatList[0] &&
                              _vm.discussionChatList[0].messages
                              ? _c(
                                  "div",
                                  { key: "discussion-" + index },
                                  [
                                    _c(
                                      "el-row",
                                      [
                                        _c("el-col", { attrs: { span: 24 } }, [
                                          _c(
                                            "div",
                                            { staticClass: "chat-date" },
                                            [
                                              _c("el-tag", [
                                                _vm._v(_vm._s(item.date)),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 24 } },
                                          _vm._l(
                                            item.charMsgInfos,
                                            function (d, ind) {
                                              return _c(
                                                "div",
                                                {
                                                  key: ind,
                                                  staticClass: "chat-receive",
                                                },
                                                [
                                                  d.chatType == 5
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "chat-date",
                                                        },
                                                        [
                                                          _c(
                                                            "el-tag",
                                                            {
                                                              attrs: {
                                                                type: "danger",
                                                                effect: "light",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(d.msg)
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : [
                                                        d.from !=
                                                          _vm.fromUser &&
                                                        d.from !=
                                                          _vm.groupToUser.userID
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "chat-container-from",
                                                                on: {
                                                                  contextmenu:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.preventDefault()
                                                                      return _vm.showDiscussionContextMenu(
                                                                        $event,
                                                                        d
                                                                      )
                                                                    },
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showDiscussionContextMenu(
                                                                        $event,
                                                                        d
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("div", [
                                                                  d.chatType ==
                                                                  1
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "chat-content-form",
                                                                          attrs:
                                                                            {
                                                                              closable: false,
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                d.fromName
                                                                              ) +
                                                                              "：" +
                                                                              _vm._s(
                                                                                d.msg
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  d.chatType ==
                                                                    2 &&
                                                                  d.fileInfo &&
                                                                  d.fileInfo.url
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "chat-content-form",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    d.fromName
                                                                                  ) +
                                                                                  "： "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "el-image",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "100px",
                                                                                  height:
                                                                                    "100px",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  "preview-src-list":
                                                                                    [
                                                                                      d
                                                                                        .fileInfo
                                                                                        .url,
                                                                                    ],
                                                                                  src: d
                                                                                    .fileInfo
                                                                                    .url,
                                                                                  fit: "cover",
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  d.chatType ==
                                                                  4
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "chat-content-form",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    d.fromName
                                                                                  ) +
                                                                                  "： "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "el-image",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "100px",
                                                                                  height:
                                                                                    "100px",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  src: "https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png",
                                                                                  fit: "cover",
                                                                                  "preview-src-list":
                                                                                    [
                                                                                      "https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png",
                                                                                    ],
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  _c(
                                                                    "i",
                                                                    {
                                                                      staticClass:
                                                                        "time-flag",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            d.time
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        d.from ==
                                                          _vm.fromUser ||
                                                        d.from ==
                                                          _vm.groupToUser.userID
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "chat-container-send",
                                                                staticStyle: {
                                                                  "text-align":
                                                                    "right",
                                                                },
                                                              },
                                                              [
                                                                _c("div", [
                                                                  d.isRead
                                                                    ? _c(
                                                                        "i",
                                                                        {
                                                                          staticClass:
                                                                            "read-flag",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "已讀"
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _c(
                                                                    "i",
                                                                    {
                                                                      staticClass:
                                                                        "time-flag",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          d.time
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  d.chatType ==
                                                                  1
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "chat-content-send",
                                                                          attrs:
                                                                            {
                                                                              closable: false,
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                d.msg
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  d.chatType ==
                                                                    2 &&
                                                                  d.fileInfo &&
                                                                  d.fileInfo.url
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _c(
                                                                            "el-image",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "100px",
                                                                                  height:
                                                                                    "100px",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  src: d
                                                                                    .fileInfo
                                                                                    .url,
                                                                                  fit: "cover",
                                                                                  "preview-src-list":
                                                                                    [
                                                                                      d
                                                                                        .fileInfo
                                                                                        .url,
                                                                                    ],
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  d.chatType ==
                                                                  4
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _c(
                                                                            "el-image",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "100px",
                                                                                  height:
                                                                                    "100px",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  src: "https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png",
                                                                                  fit: "cover",
                                                                                  "preview-src-list":
                                                                                    [
                                                                                      "https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png",
                                                                                    ],
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                ]),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                ],
                                                2
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e()
                          }
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm.panel === "chat"
                ? _c(
                    "el-input",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: _vm.chatLoading,
                        placeholder: "請輸入內容",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.sendMsg($event)
                        },
                      },
                      model: {
                        value: _vm.msg,
                        callback: function ($$v) {
                          _vm.msg = $$v
                        },
                        expression: "msg",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "prepend" },
                        [
                          _c("Upload", {
                            ref: "uploadMobileChatRef",
                            attrs: {
                              accept: ".img,.jpg,.png,.jpeg,.bmp",
                              payload: {
                                from: _vm.fromUser,
                                to: _vm.toUser ? _vm.toUser.userAccount : "",
                              },
                              "data-obj": _vm.fileObj,
                              "limit-file-count": 20,
                              "use-drag": false,
                              action: "Chat",
                              "auto-upload": true,
                              "show-file-list": false,
                              "btn-txt": "上傳",
                              "before-file-list": [],
                              "show-limit": false,
                              sendFileMsgCallback: _vm.sendFileMsg,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "append" },
                        [
                          _c("el-button", {
                            attrs: {
                              disabled: _vm.chatLoading,
                              icon: "el-icon-s-promotion",
                              type: "success",
                            },
                            on: { click: _vm.sendMsg },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.panel === "groupChat"
                ? _c(
                    "el-input",
                    {
                      staticClass: "group-sticker-input",
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled:
                          _vm.chatLoading || !_vm.groupToUser.openGroupChat,
                        placeholder: "請輸入群組訊息",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.sendMsg($event)
                        },
                      },
                      model: {
                        value: _vm.groupMsg,
                        callback: function ($$v) {
                          _vm.groupMsg = $$v
                        },
                        expression: "groupMsg",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "prepend" },
                        [
                          _c("Upload", {
                            ref: "uploadMobileGroupRef",
                            attrs: {
                              accept: ".img,.jpg,.png,.jpeg,.bmp",
                              payload: {
                                from: _vm.fromUser,
                                to: _vm.groupToUser
                                  ? _vm.groupToUser.userID
                                  : "",
                              },
                              "data-obj": _vm.fileObj,
                              "limit-file-count": 20,
                              "use-drag": false,
                              action: "Chat",
                              "auto-upload": true,
                              "show-file-list": false,
                              "btn-txt": "上傳",
                              "before-file-list": [],
                              "show-limit": false,
                              sendFileMsgCallback: _vm.sendFileMsg,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "append" },
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                disabled:
                                  _vm.chatLoading ||
                                  !_vm.groupToUser.openGroupChat,
                                placement: "top-end",
                                trigger: "click",
                                width: "540",
                                "popper-class": "sticker-popover",
                              },
                              model: {
                                value: _vm.stickerPopoverVisible,
                                callback: function ($$v) {
                                  _vm.stickerPopoverVisible = $$v
                                },
                                expression: "stickerPopoverVisible",
                              },
                            },
                            [
                              _c("div", { staticClass: "sticker-panel" }, [
                                _c(
                                  "div",
                                  { staticClass: "sticker-grid" },
                                  _vm._l(
                                    _vm.stickerGroups[
                                      _vm.stickerActiveGroup - 1
                                    ],
                                    function (sticker) {
                                      return _c("img", {
                                        key: sticker.name,
                                        staticClass: "sticker-item",
                                        attrs: {
                                          src: sticker.url,
                                          loading: "lazy",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.sendSticker(sticker)
                                          },
                                        },
                                      })
                                    }
                                  ),
                                  0
                                ),
                                _c(
                                  "div",
                                  { staticClass: "sticker-group-tabs" },
                                  _vm._l(4, function (groupIndex) {
                                    return _c(
                                      "span",
                                      {
                                        key: groupIndex,
                                        staticClass: "sticker-group-tab",
                                        class: {
                                          "is-active":
                                            _vm.stickerActiveGroup ===
                                            groupIndex,
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.stickerActiveGroup = groupIndex
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(groupIndex))]
                                    )
                                  }),
                                  0
                                ),
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass: "sticker-trigger-btn",
                                  class: {
                                    "is-disabled":
                                      _vm.chatLoading ||
                                      !_vm.groupToUser.openGroupChat,
                                  },
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  _c("img", {
                                    staticClass: "sticker-trigger-icon",
                                    attrs: { src: _vm.smileIcon },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c("el-button", {
                            attrs: {
                              disabled:
                                _vm.chatLoading ||
                                !_vm.groupToUser.openGroupChat,
                              icon: "el-icon-s-promotion",
                              type: "success",
                            },
                            on: { click: _vm.sendMsg },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.panel === "discussionChat"
                ? _c(
                    "el-input",
                    {
                      staticClass: "discussion-sticker-input",
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled:
                          _vm.discussionChatLoading ||
                          !_vm.discussionChatSwitch,
                        placeholder: "請輸入討論內容",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.sendMsg($event)
                        },
                      },
                      model: {
                        value: _vm.discussionMsg,
                        callback: function ($$v) {
                          _vm.discussionMsg = $$v
                        },
                        expression: "discussionMsg",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "prepend" },
                        [
                          _c("Upload", {
                            ref: "uploadMobileDiscussionRef",
                            attrs: {
                              accept: ".img,.jpg,.png,.jpeg,.bmp",
                              payload: {
                                from: _vm.fromUser,
                                to: _vm.discussionChatConnection,
                              },
                              "data-obj": _vm.fileObj,
                              "limit-file-count": 20,
                              "use-drag": false,
                              action: "Chat",
                              "auto-upload": true,
                              "show-file-list": false,
                              "btn-txt": "上傳",
                              "before-file-list": [],
                              "show-limit": false,
                              sendFileMsgCallback: _vm.sendFileMsg,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "append" },
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                disabled:
                                  _vm.discussionChatLoading ||
                                  !_vm.discussionChatSwitch,
                                placement: "top-end",
                                trigger: "click",
                                width: "540",
                                "popper-class": "sticker-popover",
                              },
                              model: {
                                value: _vm.discussionStickerPopoverVisible,
                                callback: function ($$v) {
                                  _vm.discussionStickerPopoverVisible = $$v
                                },
                                expression: "discussionStickerPopoverVisible",
                              },
                            },
                            [
                              _c("div", { staticClass: "sticker-panel" }, [
                                _c(
                                  "div",
                                  { staticClass: "sticker-grid" },
                                  _vm._l(
                                    _vm.stickerGroups[
                                      _vm.stickerActiveGroup - 1
                                    ],
                                    function (sticker) {
                                      return _c("img", {
                                        key: sticker.name,
                                        staticClass: "sticker-item",
                                        attrs: {
                                          src: sticker.url,
                                          loading: "lazy",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.sendDiscussionSticker(
                                              sticker
                                            )
                                          },
                                        },
                                      })
                                    }
                                  ),
                                  0
                                ),
                                _c(
                                  "div",
                                  { staticClass: "sticker-group-tabs" },
                                  _vm._l(4, function (groupIndex) {
                                    return _c(
                                      "span",
                                      {
                                        key: groupIndex,
                                        staticClass: "sticker-group-tab",
                                        class: {
                                          "is-active":
                                            _vm.stickerActiveGroup ===
                                            groupIndex,
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.stickerActiveGroup = groupIndex
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(groupIndex))]
                                    )
                                  }),
                                  0
                                ),
                              ]),
                              _c(
                                "span",
                                {
                                  staticClass: "sticker-trigger-btn",
                                  class: {
                                    "is-disabled":
                                      _vm.discussionChatLoading ||
                                      !_vm.discussionChatSwitch,
                                  },
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  _c("img", {
                                    staticClass: "sticker-trigger-icon",
                                    attrs: { src: _vm.smileIcon },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c("el-button", {
                            attrs: {
                              disabled:
                                _vm.discussionChatLoading ||
                                !_vm.discussionChatSwitch,
                              icon: "el-icon-s-promotion",
                              type: "success",
                            },
                            on: { click: _vm.sendMsg },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-tabs",
        {
          staticClass: "full-height",
          attrs: { type: "border-card" },
          model: {
            value: _vm.panel,
            callback: function ($$v) {
              _vm.panel = $$v
            },
            expression: "panel",
          },
        },
        [
          _c(
            "el-tab-pane",
            {
              staticClass: "full-height",
              attrs: { label: "團體群聊", name: "groupChat" },
            },
            [
              _c(
                "el-row",
                { staticClass: "row-box full-height" },
                [
                  _c(
                    "el-col",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading || _vm.createLoading,
                          expression: "listLoading || createLoading",
                        },
                      ],
                      staticClass: "full-height",
                      attrs: { xs: 24, sm: 24, md: 9, lg: 9, xl: 9 },
                    },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "box-card el-card-define full-height",
                          attrs: { "body-style": { height: "100%" } },
                        },
                        [
                          _vm.groupChatDirectInfo &&
                          _vm.groupChatDirectInfo.length > 0
                            ? _c(
                                "div",
                                { staticClass: "full-height" },
                                [
                                  _c(
                                    "el-table",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        height: "100%",
                                        data: _vm.groupChatDirectInfo,
                                        size: "mini",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: { width: "50" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-avatar", {
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                    },
                                                    attrs: {
                                                      shape: "square",
                                                      size: "large",
                                                      src: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.selectedGroup(
                                                          scope.row.from
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          60160951
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        staticStyle: { width: "100%" },
                                        attrs: { prop: "fromUserName" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        cursor: "pointer",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.selectedGroup(
                                                            scope.row.from
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.formatShowUserName(
                                                              scope.row
                                                                .fromUserName
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                      scope.row.messages &&
                                                      scope.row.messages.msg
                                                        ? _c("el-alert", {
                                                            attrs: {
                                                              closable: false,
                                                              title:
                                                                _vm.cutText(
                                                                  scope.row
                                                                    .messages
                                                                    .msg
                                                                ),
                                                              type: "info",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3951267777
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: { width: "60" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  scope.row.messages &&
                                                  scope.row.messages.time
                                                    ? _c(
                                                        "i",
                                                        {
                                                          staticStyle: {
                                                            color: "#ccc",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row.messages
                                                                .time
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  scope.row.notReadCount > 0
                                                    ? _c(
                                                        "el-tag",
                                                        {
                                                          attrs: {
                                                            type: "danger",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .notReadCount
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          612645868
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm.device == "desktop" &&
                  _vm.panel === "groupChat" &&
                  _vm.groupToUser !== undefined &&
                  _vm.groupToUser.userAccount
                    ? _c(
                        "el-col",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.chatLoading,
                              expression: "chatLoading",
                            },
                          ],
                          staticClass: "full-height hidden-xs-only",
                          staticStyle: { position: "relative", height: "92%" },
                          attrs: { span: 14, offset: 1 },
                        },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass:
                                "box-card el-card-define chat-window full-height",
                              attrs: {
                                "body-style": {
                                  height: "92%",
                                  "overflow-y": "scroll",
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "clearfix",
                                  attrs: { slot: "header" },
                                  slot: "header",
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatShowUserName(
                                          _vm.groupToUser.userName
                                        )
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticStyle: { float: "right" } },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-right": "8px",
                                            "font-size": "12px",
                                            color: "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "若關閉此團所有人皆無法使用群組聊天功能"
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-right": "8px",
                                            "font-size": "14px",
                                          },
                                          style: {
                                            color: _vm.groupToUser.openGroupChat
                                              ? "#000"
                                              : "#409EFF",
                                          },
                                        },
                                        [_vm._v("關")]
                                      ),
                                      _c("el-switch", {
                                        attrs: {
                                          disabled: _vm.switchLoading,
                                          "active-color": "#13ce66",
                                          "inactive-color": "#ff4949",
                                        },
                                        on: {
                                          change: _vm.handleOpenGroupChatChange,
                                        },
                                        model: {
                                          value: _vm.groupToUser.openGroupChat,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.groupToUser,
                                              "openGroupChat",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "groupToUser.openGroupChat",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-left": "8px",
                                            "font-size": "14px",
                                          },
                                          style: {
                                            color: _vm.groupToUser.openGroupChat
                                              ? "#409EFF"
                                              : "#000",
                                          },
                                        },
                                        [_vm._v("開")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm.panel === "groupChat" &&
                              _vm.filtered_group_list.length > 0 &&
                              _vm.filtered_group_list[0] &&
                              _vm.filtered_group_list[0].messages &&
                              _vm.filtered_group_list[0].messages.length > 0
                                ? _vm._l(
                                    _vm.filtered_group_list[0].messages,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        { key: index },
                                        [
                                          _c(
                                            "el-row",
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 24 } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "chat-date",
                                                    },
                                                    [
                                                      _c("el-tag", [
                                                        _vm._v(
                                                          _vm._s(item.date)
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 24 } },
                                                _vm._l(
                                                  item.charMsgInfos,
                                                  function (d, ind) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: ind,
                                                        staticClass:
                                                          "chat-receive",
                                                      },
                                                      [
                                                        d.from !=
                                                          _vm.fromUser &&
                                                        d.from !=
                                                          _vm.groupToUser.userID
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "chat-container-from",
                                                              },
                                                              [
                                                                _c("div", [
                                                                  d.chatType ==
                                                                  1
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "chat-content-form",
                                                                          attrs:
                                                                            {
                                                                              closable: false,
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                d.from
                                                                              ) +
                                                                              "：" +
                                                                              _vm._s(
                                                                                d.msg
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  d.chatType ==
                                                                    2 &&
                                                                  d.fileInfo &&
                                                                  d.fileInfo.url
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "chat-content-form",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    d.from
                                                                                  ) +
                                                                                  "： "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "el-image",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "100px",
                                                                                  height:
                                                                                    "100px",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  "preview-src-list":
                                                                                    [
                                                                                      d
                                                                                        .fileInfo
                                                                                        .url,
                                                                                    ],
                                                                                  src: d
                                                                                    .fileInfo
                                                                                    .url,
                                                                                  fit: "cover",
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  d.chatType ==
                                                                  4
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "chat-content-form",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    d.from
                                                                                  ) +
                                                                                  "： "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "el-image",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "100px",
                                                                                  height:
                                                                                    "100px",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  src: "https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png",
                                                                                  fit: "cover",
                                                                                  "preview-src-list":
                                                                                    [
                                                                                      "https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png",
                                                                                    ],
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  _c(
                                                                    "i",
                                                                    {
                                                                      staticClass:
                                                                        "time-flag",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            d.time
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        d.from ==
                                                          _vm.fromUser ||
                                                        d.from ==
                                                          _vm.groupToUser.userID
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "chat-container-send",
                                                                staticStyle: {
                                                                  "text-align":
                                                                    "right",
                                                                },
                                                              },
                                                              [
                                                                _c("div", [
                                                                  d.isRead
                                                                    ? _c(
                                                                        "i",
                                                                        {
                                                                          staticClass:
                                                                            "read-flag",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "已讀"
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _c(
                                                                    "i",
                                                                    {
                                                                      staticClass:
                                                                        "time-flag",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          d.time
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  d.chatType ==
                                                                  1
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "chat-content-send",
                                                                          attrs:
                                                                            {
                                                                              closable: false,
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                d.msg
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  d.chatType ==
                                                                    2 &&
                                                                  d.fileInfo &&
                                                                  d.fileInfo.url
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _c(
                                                                            "el-image",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "100px",
                                                                                  height:
                                                                                    "100px",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  src: d
                                                                                    .fileInfo
                                                                                    .url,
                                                                                  fit: "cover",
                                                                                  "preview-src-list":
                                                                                    [
                                                                                      d
                                                                                        .fileInfo
                                                                                        .url,
                                                                                    ],
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  d.chatType ==
                                                                  4
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _c(
                                                                            "el-image",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "100px",
                                                                                  height:
                                                                                    "100px",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  src: "https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png",
                                                                                  fit: "cover",
                                                                                  "preview-src-list":
                                                                                    [
                                                                                      "https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png",
                                                                                    ],
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                ]),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm.panel === "groupChat"
                            ? _c(
                                "el-input",
                                {
                                  staticClass: "group-sticker-input",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled:
                                      _vm.chatLoading ||
                                      !_vm.groupToUser.openGroupChat,
                                    placeholder: "請輸入內容",
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.sendMsg($event)
                                    },
                                  },
                                  model: {
                                    value: _vm.groupMsg,
                                    callback: function ($$v) {
                                      _vm.groupMsg = $$v
                                    },
                                    expression: "groupMsg",
                                  },
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "prepend" },
                                    [
                                      _c("Upload", {
                                        ref: "uploadDesktopGroupRef",
                                        attrs: {
                                          accept: ".img,.jpg,.png,.jpeg,.bmp",
                                          payload: {
                                            from: _vm.fromUser,
                                            to: _vm.groupToUser
                                              ? _vm.groupToUser.userID
                                              : "",
                                          },
                                          "data-obj": _vm.fileObj,
                                          "limit-file-count": 20,
                                          "use-drag": false,
                                          action: "Chat",
                                          "auto-upload": true,
                                          "show-file-list": false,
                                          multiple: false,
                                          "btn-txt": "上傳",
                                          "before-file-list": [],
                                          "show-limit": false,
                                          sendFileMsgCallback: _vm.sendFileMsg,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "template",
                                    { slot: "append" },
                                    [
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            disabled:
                                              _vm.chatLoading ||
                                              !_vm.groupToUser.openGroupChat,
                                            placement: "top-end",
                                            trigger: "click",
                                            width: "540",
                                            "popper-class": "sticker-popover",
                                          },
                                          model: {
                                            value: _vm.stickerPopoverVisible,
                                            callback: function ($$v) {
                                              _vm.stickerPopoverVisible = $$v
                                            },
                                            expression: "stickerPopoverVisible",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "sticker-panel" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "sticker-grid" },
                                                _vm._l(
                                                  _vm.stickerGroups[
                                                    _vm.stickerActiveGroup - 1
                                                  ],
                                                  function (sticker) {
                                                    return _c("img", {
                                                      key: sticker.name,
                                                      staticClass:
                                                        "sticker-item",
                                                      attrs: {
                                                        src: sticker.url,
                                                        loading: "lazy",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.sendSticker(
                                                            sticker
                                                          )
                                                        },
                                                      },
                                                    })
                                                  }
                                                ),
                                                0
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "sticker-group-tabs",
                                                },
                                                _vm._l(
                                                  4,
                                                  function (groupIndex) {
                                                    return _c(
                                                      "span",
                                                      {
                                                        key: groupIndex,
                                                        staticClass:
                                                          "sticker-group-tab",
                                                        class: {
                                                          "is-active":
                                                            _vm.stickerActiveGroup ===
                                                            groupIndex,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            _vm.stickerActiveGroup =
                                                              groupIndex
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(groupIndex)
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "sticker-trigger-btn",
                                              class: {
                                                "is-disabled":
                                                  _vm.chatLoading ||
                                                  !_vm.groupToUser
                                                    .openGroupChat,
                                              },
                                              attrs: { slot: "reference" },
                                              slot: "reference",
                                            },
                                            [
                                              _c("img", {
                                                staticClass:
                                                  "sticker-trigger-icon",
                                                attrs: { src: _vm.smileIcon },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c("el-button", {
                                        attrs: {
                                          disabled:
                                            _vm.chatLoading ||
                                            !_vm.groupToUser.openGroupChat,
                                          icon: "el-icon-s-promotion",
                                          type: "success",
                                        },
                                        on: { click: _vm.sendMsg },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.envMode != "production"
            ? _c(
                "el-tab-pane",
                {
                  staticClass: "full-height",
                  attrs: { label: "討論區", name: "discussionChat" },
                },
                [
                  _c(
                    "el-row",
                    { staticClass: "row-box full-height" },
                    [
                      _c(
                        "el-col",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.discussionChatLoading,
                              expression: "discussionChatLoading",
                            },
                          ],
                          staticClass: "full-height",
                          staticStyle: { position: "relative", height: "92%" },
                          attrs: { span: 24 },
                        },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass:
                                "box-card el-card-define chat-window full-height",
                              attrs: {
                                "body-style": {
                                  height: "92%",
                                  "overflow-y": "scroll",
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "clearfix",
                                  attrs: { slot: "header" },
                                  slot: "header",
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      '所有APP使用者在活動結束後皆會自動加入討論區 (團體管理/其他設定/顯示資訊，設定"隱藏"則不會加入)'
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticStyle: { float: "right" } },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-right": "8px",
                                            "font-size": "12px",
                                            color: "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "※點擊旅客姓名可將他移除本討論區"
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-right": "8px",
                                            "font-size": "12px",
                                            color: "red",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "若關閉此功能所有人皆無法使用討論區聊天功能"
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-right": "8px",
                                            "font-size": "14px",
                                          },
                                          style: {
                                            color: _vm.discussionChatSwitch
                                              ? "#000"
                                              : "#409EFF",
                                          },
                                        },
                                        [_vm._v("關")]
                                      ),
                                      _c("el-switch", {
                                        attrs: {
                                          disabled: _vm.switchLoading,
                                          "active-color": "#13ce66",
                                          "inactive-color": "#ff4949",
                                        },
                                        on: {
                                          change:
                                            _vm.handleOpenDiscussionChatChange,
                                        },
                                        model: {
                                          value: _vm.discussionChatSwitch,
                                          callback: function ($$v) {
                                            _vm.discussionChatSwitch = $$v
                                          },
                                          expression: "discussionChatSwitch",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-left": "8px",
                                            "font-size": "14px",
                                          },
                                          style: {
                                            color: _vm.discussionChatSwitch
                                              ? "#409EFF"
                                              : "#000",
                                          },
                                        },
                                        [_vm._v("開")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm.discussionChatList.length > 0 &&
                              _vm.discussionChatList[0] &&
                              _vm.discussionChatList[0].messages &&
                              _vm.discussionChatList[0].messages.length > 0
                                ? _vm._l(
                                    _vm.discussionChatList[0].messages,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        { key: "discussion-" + index },
                                        [
                                          _c(
                                            "el-row",
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 24 } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "chat-date",
                                                    },
                                                    [
                                                      _c("el-tag", [
                                                        _vm._v(
                                                          _vm._s(item.date)
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 24 } },
                                                _vm._l(
                                                  item.charMsgInfos,
                                                  function (d, ind) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: ind,
                                                        staticClass:
                                                          "chat-receive",
                                                      },
                                                      [
                                                        d.chatType == 5
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "chat-date",
                                                              },
                                                              [
                                                                _c(
                                                                  "el-tag",
                                                                  {
                                                                    attrs: {
                                                                      type: "danger",
                                                                      effect:
                                                                        "light",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        d.msg
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : [
                                                              d.from !=
                                                                _vm.fromUser &&
                                                              d.from !=
                                                                _vm.groupToUser
                                                                  .userID
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "chat-container-from",
                                                                      on: {
                                                                        contextmenu:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.preventDefault()
                                                                            return _vm.showDiscussionContextMenu(
                                                                              $event,
                                                                              d
                                                                            )
                                                                          },
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.showDiscussionContextMenu(
                                                                              $event,
                                                                              d
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          d.chatType ==
                                                                          1
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "chat-content-form",
                                                                                  attrs:
                                                                                    {
                                                                                      closable: false,
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        d.fromName
                                                                                      ) +
                                                                                      "：" +
                                                                                      _vm._s(
                                                                                        d.msg
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                          d.chatType ==
                                                                            2 &&
                                                                          d.fileInfo &&
                                                                          d
                                                                            .fileInfo
                                                                            .url
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "chat-content-form",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            d.fromName
                                                                                          ) +
                                                                                          "： "
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "el-image",
                                                                                    {
                                                                                      staticStyle:
                                                                                        {
                                                                                          width:
                                                                                            "100px",
                                                                                          height:
                                                                                            "100px",
                                                                                        },
                                                                                      attrs:
                                                                                        {
                                                                                          "preview-src-list":
                                                                                            [
                                                                                              d
                                                                                                .fileInfo
                                                                                                .url,
                                                                                            ],
                                                                                          src: d
                                                                                            .fileInfo
                                                                                            .url,
                                                                                          fit: "cover",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e(),
                                                                          d.chatType ==
                                                                          4
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "chat-content-form",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " " +
                                                                                          _vm._s(
                                                                                            d.fromName
                                                                                          ) +
                                                                                          "： "
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "el-image",
                                                                                    {
                                                                                      staticStyle:
                                                                                        {
                                                                                          width:
                                                                                            "100px",
                                                                                          height:
                                                                                            "100px",
                                                                                        },
                                                                                      attrs:
                                                                                        {
                                                                                          src: "https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png",
                                                                                          fit: "cover",
                                                                                          "preview-src-list":
                                                                                            [
                                                                                              "https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png",
                                                                                            ],
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e(),
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "time-flag",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    d.time
                                                                                  )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              d.from ==
                                                                _vm.fromUser ||
                                                              d.from ==
                                                                _vm.groupToUser
                                                                  .userID
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "chat-container-send",
                                                                      staticStyle:
                                                                        {
                                                                          "text-align":
                                                                            "right",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          d.isRead
                                                                            ? _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "read-flag",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "已讀"
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "time-flag",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  d.time
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          d.chatType ==
                                                                          1
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "chat-content-send",
                                                                                  attrs:
                                                                                    {
                                                                                      closable: false,
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        d.msg
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                          d.chatType ==
                                                                            2 &&
                                                                          d.fileInfo &&
                                                                          d
                                                                            .fileInfo
                                                                            .url
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  _c(
                                                                                    "el-image",
                                                                                    {
                                                                                      staticStyle:
                                                                                        {
                                                                                          width:
                                                                                            "100px",
                                                                                          height:
                                                                                            "100px",
                                                                                        },
                                                                                      attrs:
                                                                                        {
                                                                                          src: d
                                                                                            .fileInfo
                                                                                            .url,
                                                                                          fit: "cover",
                                                                                          "preview-src-list":
                                                                                            [
                                                                                              d
                                                                                                .fileInfo
                                                                                                .url,
                                                                                            ],
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e(),
                                                                          d.chatType ==
                                                                          4
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  _c(
                                                                                    "el-image",
                                                                                    {
                                                                                      staticStyle:
                                                                                        {
                                                                                          width:
                                                                                            "100px",
                                                                                          height:
                                                                                            "100px",
                                                                                        },
                                                                                      attrs:
                                                                                        {
                                                                                          src: "https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png",
                                                                                          fit: "cover",
                                                                                          "preview-src-list":
                                                                                            [
                                                                                              "https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png",
                                                                                            ],
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                      ],
                                                      2
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                          _c(
                            "el-input",
                            {
                              staticClass: "discussion-sticker-input",
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled:
                                  _vm.discussionChatLoading ||
                                  !_vm.discussionChatSwitch,
                                placeholder: "請輸入討論內容",
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.sendMsg($event)
                                },
                              },
                              model: {
                                value: _vm.discussionMsg,
                                callback: function ($$v) {
                                  _vm.discussionMsg = $$v
                                },
                                expression: "discussionMsg",
                              },
                            },
                            [
                              _c(
                                "template",
                                { slot: "prepend" },
                                [
                                  _c("Upload", {
                                    ref: "uploadDiscussionRef",
                                    attrs: {
                                      accept: ".img,.jpg,.png,.jpeg,.bmp",
                                      payload: {
                                        from: _vm.fromUser,
                                        to: _vm.discussionChatConnection,
                                      },
                                      "data-obj": _vm.fileObj,
                                      "limit-file-count": 20,
                                      "use-drag": false,
                                      action: "Chat",
                                      "auto-upload": true,
                                      "show-file-list": false,
                                      multiple: false,
                                      "btn-txt": "上傳",
                                      "before-file-list": [],
                                      "show-limit": false,
                                      sendFileMsgCallback: _vm.sendFileMsg,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "template",
                                { slot: "append" },
                                [
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.discussionChatLoading ||
                                          !_vm.discussionChatSwitch,
                                        placement: "top-end",
                                        trigger: "click",
                                        width: "540",
                                        "popper-class": "sticker-popover",
                                      },
                                      model: {
                                        value:
                                          _vm.discussionStickerPopoverVisible,
                                        callback: function ($$v) {
                                          _vm.discussionStickerPopoverVisible =
                                            $$v
                                        },
                                        expression:
                                          "discussionStickerPopoverVisible",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "sticker-panel" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "sticker-grid" },
                                            _vm._l(
                                              _vm.stickerGroups[
                                                _vm.stickerActiveGroup - 1
                                              ],
                                              function (sticker) {
                                                return _c("img", {
                                                  key: sticker.name,
                                                  staticClass: "sticker-item",
                                                  attrs: {
                                                    src: sticker.url,
                                                    loading: "lazy",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.sendDiscussionSticker(
                                                        sticker
                                                      )
                                                    },
                                                  },
                                                })
                                              }
                                            ),
                                            0
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "sticker-group-tabs",
                                            },
                                            _vm._l(4, function (groupIndex) {
                                              return _c(
                                                "span",
                                                {
                                                  key: groupIndex,
                                                  staticClass:
                                                    "sticker-group-tab",
                                                  class: {
                                                    "is-active":
                                                      _vm.stickerActiveGroup ===
                                                      groupIndex,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.stickerActiveGroup =
                                                        groupIndex
                                                    },
                                                  },
                                                },
                                                [_vm._v(_vm._s(groupIndex))]
                                              )
                                            }),
                                            0
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "sticker-trigger-btn",
                                          class: {
                                            "is-disabled":
                                              _vm.discussionChatLoading ||
                                              !_vm.discussionChatSwitch,
                                          },
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "sticker-trigger-icon",
                                            attrs: { src: _vm.smileIcon },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c("el-button", {
                                    attrs: {
                                      disabled:
                                        _vm.discussionChatLoading ||
                                        !_vm.discussionChatSwitch,
                                      icon: "el-icon-s-promotion",
                                      type: "success",
                                    },
                                    on: { click: _vm.sendMsg },
                                  }),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-tab-pane",
            {
              staticClass: "full-height",
              attrs: { label: "智遊旅程對話", name: "chat" },
            },
            [
              _c(
                "el-row",
                { staticClass: "row-box full-height" },
                [
                  _c(
                    "el-col",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading || _vm.createLoading,
                          expression: "listLoading || createLoading",
                        },
                      ],
                      staticClass: "full-height",
                      attrs: { xs: 24, sm: 24, md: 9, lg: 9, xl: 9 },
                    },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "box-card el-card-define full-height",
                          attrs: { "body-style": { height: "100%" } },
                        },
                        [
                          _vm.chatDirectInfo && _vm.chatDirectInfo.length > 0
                            ? _c(
                                "div",
                                { staticClass: "full-height" },
                                [
                                  _c(
                                    "el-table",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        height: "100%",
                                        data: _vm.chatDirectInfo,
                                        size: "mini",
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: { width: "50" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-avatar", {
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                    },
                                                    attrs: {
                                                      shape: "square",
                                                      size: "large",
                                                      src: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.selectedUser(
                                                          scope.row.from
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          645167609
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        staticStyle: { width: "100%" },
                                        attrs: { prop: "fromUserName" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        cursor: "pointer",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.selectedUser(
                                                            scope.row.from
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.formatShowUserName(
                                                              scope.row
                                                                .fromUserName
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                      scope.row.messages &&
                                                      scope.row.messages.msg
                                                        ? _c("el-alert", {
                                                            attrs: {
                                                              closable: false,
                                                              title:
                                                                _vm.cutText(
                                                                  scope.row
                                                                    .messages
                                                                    .msg
                                                                ),
                                                              type: "info",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2898793071
                                        ),
                                      }),
                                      _c("el-table-column", {
                                        attrs: { width: "60" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  scope.row.messages &&
                                                  scope.row.messages.time
                                                    ? _c(
                                                        "i",
                                                        {
                                                          staticStyle: {
                                                            color: "#ccc",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row.messages
                                                                .time
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  scope.row.notReadCount > 0
                                                    ? _c(
                                                        "el-tag",
                                                        {
                                                          attrs: {
                                                            type: "danger",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row
                                                                .notReadCount
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          612645868
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm.device == "desktop" &&
                  _vm.toUser !== undefined &&
                  _vm.toUser.userAccount
                    ? _c(
                        "el-col",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.chatLoading,
                              expression: "chatLoading",
                            },
                          ],
                          staticClass: "full-height hidden-xs-only",
                          staticStyle: { position: "relative", height: "92%" },
                          attrs: { span: 14, offset: 1 },
                        },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass:
                                "box-card el-card-define chat-window full-height",
                              attrs: {
                                "body-style": {
                                  height: "92%",
                                  "overflow-y": "scroll",
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "clearfix",
                                  attrs: { slot: "header" },
                                  slot: "header",
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatShowUserName(
                                          _vm.toUser.userName
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _vm.panel === "chat" &&
                              _vm.filtered_list.length > 0 &&
                              _vm.filtered_list[0].messages &&
                              _vm.filtered_list[0].messages.length > 0
                                ? _vm._l(
                                    _vm.filtered_list[0].messages,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        { key: index },
                                        [
                                          _c(
                                            "el-row",
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 24 } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "chat-date",
                                                    },
                                                    [
                                                      _c("el-tag", [
                                                        _vm._v(
                                                          _vm._s(item.date)
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-row",
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 24 } },
                                                _vm._l(
                                                  item.charMsgInfos,
                                                  function (d, ind) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: ind,
                                                        staticClass:
                                                          "chat-receive",
                                                      },
                                                      [
                                                        d.from != _vm.fromUser
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "chat-container-from",
                                                              },
                                                              [
                                                                _c("div", [
                                                                  d.chatType ==
                                                                  1
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "chat-content-form",
                                                                          attrs:
                                                                            {
                                                                              closable: false,
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                d.msg
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  d.chatType ==
                                                                    2 &&
                                                                  d.fileInfo &&
                                                                  d.fileInfo.url
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _c(
                                                                            "el-image",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "100px",
                                                                                  height:
                                                                                    "100px",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  "preview-src-list":
                                                                                    [
                                                                                      d
                                                                                        .fileInfo
                                                                                        .url,
                                                                                    ],
                                                                                  src: d
                                                                                    .fileInfo
                                                                                    .url,
                                                                                  fit: "cover",
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  _c(
                                                                    "i",
                                                                    {
                                                                      staticClass:
                                                                        "time-flag",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            d.time
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        d.from == _vm.fromUser
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "chat-container-send",
                                                                staticStyle: {
                                                                  "text-align":
                                                                    "right",
                                                                },
                                                              },
                                                              [
                                                                _c("div", [
                                                                  d.isRead
                                                                    ? _c(
                                                                        "i",
                                                                        {
                                                                          staticClass:
                                                                            "read-flag",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "已讀"
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _c(
                                                                    "i",
                                                                    {
                                                                      staticClass:
                                                                        "time-flag",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          d.time
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  d.chatType ==
                                                                  1
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "chat-content-send",
                                                                          attrs:
                                                                            {
                                                                              closable: false,
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                d.msg
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  d.chatType ==
                                                                    2 &&
                                                                  d.fileInfo &&
                                                                  d.fileInfo.url
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _c(
                                                                            "el-image",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "100px",
                                                                                  height:
                                                                                    "100px",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  src: d
                                                                                    .fileInfo
                                                                                    .url,
                                                                                  fit: "cover",
                                                                                  "preview-src-list":
                                                                                    [
                                                                                      d
                                                                                        .fileInfo
                                                                                        .url,
                                                                                    ],
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                ]),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm.panel === "chat"
                            ? _c(
                                "el-input",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.chatLoading,
                                    placeholder: "請輸入內容",
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.sendMsg($event)
                                    },
                                  },
                                  model: {
                                    value: _vm.msg,
                                    callback: function ($$v) {
                                      _vm.msg = $$v
                                    },
                                    expression: "msg",
                                  },
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "prepend" },
                                    [
                                      _c("Upload", {
                                        ref: "uploadDesktopChatRef",
                                        attrs: {
                                          accept: ".img,.jpg,.png,.jpeg,.bmp",
                                          payload: {
                                            from: _vm.fromUser,
                                            to: _vm.toUser.userAccount,
                                          },
                                          "data-obj": _vm.fileObj,
                                          "limit-file-count": 20,
                                          "use-drag": false,
                                          action: "Chat",
                                          "auto-upload": true,
                                          "show-file-list": false,
                                          multiple: false,
                                          "btn-txt": "上傳",
                                          "before-file-list": [],
                                          "show-limit": false,
                                          sendFileMsgCallback: _vm.sendFileMsg,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "template",
                                    { slot: "append" },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          disabled: _vm.chatLoading,
                                          icon: "el-icon-s-promotion",
                                          type: "success",
                                        },
                                        on: { click: _vm.sendMsg },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            {
              staticClass: "full-height",
              attrs: { label: "好友列表", name: "userList" },
            },
            [
              _c(
                "el-row",
                { staticClass: "row-box full-height" },
                [
                  _c(
                    "el-col",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      staticClass: "full-height",
                      attrs: { span: 6, xs: 24 },
                    },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "box-card el-card-define full-height",
                          attrs: { "body-style": { height: "100%" } },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "full-height" },
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.userList,
                                    height: "100%",
                                    size: "mini",
                                  },
                                  on: { "row-dblclick": _vm.rowDbClick },
                                },
                                [
                                  _c(
                                    "el-table-column",
                                    {
                                      attrs: {
                                        prop: "userAccount",
                                        width: "50",
                                      },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectedUser(
                                                _vm.scope.row.userAccount
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("el-avatar", {
                                            attrs: {
                                              shape: "square",
                                              size: "medium",
                                              src: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c("el-table-column", {
                                    staticStyle: { width: "100%" },
                                    attrs: { prop: "userName" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "a",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.selectedUser(
                                                      scope.row.userAccount
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatShowUserName(
                                                      scope.row.userName
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showContextMenu
        ? _c(
            "div",
            {
              ref: "contextMenu",
              staticClass: "context-menu",
              style: {
                left: _vm.contextMenuX + "px",
                top: _vm.contextMenuY + "px",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "context-menu-item",
                  on: { click: _vm.removeFromDiscussion },
                },
                [_vm._v("移出討論區")]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }